import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

function WhiteTextTypography({
  align,
  gutterBottom,
  children,
  fontSize,
  fontWeight,
}) {
  const useStyles = makeStyles({
    root: {
      color: 'white',
      fontSize,
      lineHeight: 1.0,
      fontWeight,
      fontFamily: 'Noto Sans TC',
    },
  });

  const classes = useStyles();

  return (
    <Typography
      classes={{ root: classes.root }}
      align={align}
      gutterBottom={gutterBottom}
    >
      {children}
    </Typography>
  );
}

WhiteTextTypography.propTypes = {
  align: PropTypes.string,
  gutterBottom: PropTypes.bool,
  children: PropTypes.node,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.string,
};

WhiteTextTypography.defaultProps = {
  align: 'left',
  gutterBottom: true,
  children: null,
  fontSize: 15,
  fontWeight: 'regular',
};

export default WhiteTextTypography;
